import React, { FC } from "react";

const ResetPassword: FC = (props) => {
  return <div></div>;
};

export default ResetPassword;
